<template>



    <div class="add_contacts_form_container">

        <div class="inputs_container">
            <InputMaterialWrap
                v-model="firstName"
                :label="$t('components.shared.addContacts.formFirstNameLabel')"
                validate='required'
                input-id="contactFirstName">
            </InputMaterialWrap>

            <InputMaterialWrap
                v-model="lastName"
                :label="$t('components.shared.addContacts.formLastNameLabel')"
                validate='required'
                input-id="contactLastName">
            </InputMaterialWrap>

            <InputMaterialWrap
                v-model="email"
                :label="$t('components.shared.addContacts.formEmailLabel')"
                validate='required|email'
                input-id="contactEmail">
            </InputMaterialWrap>

            <span class="add_eval_to_list button is-info is-outlined"
                :disabled="!isFormValid"
                @click="addEvaluation">
                {{ $t('components.shared.addContacts.formAddContactButton', {contactLabel: contactLabel}) }}
            </span>

            <button @click="$emit('choiceClicked', 'csv')" class="import_csv_button button is-info is-outlined">{{ $t('components.shared.addContacts.importCsvButton') }}</button>
        </div>

    </div>

</template>


<script>

export default {
    name: 'AddContactsForm',
    props: {
        contactLabel: {
            type: String,
            default: 'contact'
        }    
    },
    data(){
        return {    
            firstName: "",
            lastName: "",
            email: ""
        }
    },
    computed: {
        isFormValid(){
            if (this.fields.contactEmail && this.fields.contactFirstName && this.fields.contactLastName){
                return (this.fields.contactEmail.valid && this.fields.contactFirstName.valid && this.fields.contactLastName.valid)
            }else{
                return false
            }
        }
    },
    methods: {
        resetEvalForm(){
            this.firstName = ""
            this.lastName = ""
            this.email = ""
        },
        addEvaluation(){
            this.$validator.validateAll()
            if(this.isFormValid){
                this.$emit('contactAdded', {first_name: this.firstName, last_name: this.lastName, email: this.email, docs_ids: []})
                this.resetEvalForm()
            }
        }
    }
}
</script>

<style lang="scss" >
    .title_add_contact{
        display: flex;
        align-items: center;
        .title_add_contact_icon_back{
            font-size: 1.5rem;
            line-height: 30px;
            margin-right: 8px;
            border: 2px solid $grey-light;
            width: 32px;
            height: 32px;
            text-align: center;
            border-radius: 100%;
            cursor: pointer;
            &:hover{
                color: $info;
                border-color: $info;
            }
        }
    }
    .add_contacts_form_container{
        max-width: 450px;
        margin-left: auto;
    }
    .add_eval_to_list{
        width: 100%;
    }
    .mini_notice{
        padding: 12px 0 0;
    }
    .import_csv_button{
        margin-top: 12px;
        width: 100%;
    }
</style>